export enum AppLayout {
    Normal,
    ViewHeight
}
